<template>
  <product-variant-selection
    v-if="product"
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    as-form
    :attribute-selection-labels
    :error
    :handle-next-attribute
    :inventory
    :is-coming-soon
    :pending
    :product
    :selected-variant
    @select-color="selectColor"
    @select-size="selectSize"
  >
    <template #size-chart>
      <slot name="size-chart" />
    </template>
    <template #size-advice>
      <slot name="size-advice" />
    </template>
  </product-variant-selection>
</template>

<script lang="ts" setup>
defineSlots<{
  'size-chart': () => void
  'size-advice': () => void
}>()

const {
  attributeSelection,
  attributeSelectionFormRef,
  attributeSelectionLabels,
  error,
  handleNextAttribute,
  inventory,
  isComingSoon,
  pending,
  product,
  selectColor,
  selectSize,
  selectedVariant
} = usePdp()
</script>
